/**
 * Sube suzgeci — 040 gibi `lokasyon` kolonu TASIYAN satirlar icin, ISTEMCIDE (040 paylasilan yuzey; SQL'ine
 * dokunulmaz, ayni onbellek girdisi tum subeleri besler). `sube` null ise kimlik. Birebir metin
 * eslesmesi: gevsek eslesme ('Merkez' ⊂ 'Merkez Depo') ciroyu sessizce sisirirdi.
 */
export function subeSuz<T extends { lokasyon: unknown }>(rows: T[], sube: string | null): T[] {
  if (sube === null) return rows;
  return rows.filter((r) => String(r.lokasyon ?? '') === sube);
}

/**
 * G2 — kanal suzgeci, `kanal_grup`/`kanal` TASIYAN satirlar icin (istemcide; 040'in SQL'i degismez).
 * Grup secimi grubun tum kanallarini, tek kanal secimi yalniz o kanali birakir; ds'lerdeki
 * `kanal_grup = @KANAL OR kanal = @KANAL` kuraliyla AYNI.
 */
export function kanalSuz<T extends { kanal_grup: unknown; kanal: unknown }>(rows: T[], kanal: string | null): T[] {
  if (kanal === null) return rows;
  return rows.filter((r) => String(r.kanal_grup ?? '') === kanal || String(r.kanal ?? '') === kanal);
}
